import { render, staticRenderFns } from "./TenancyTerm.vue?vue&type=template&id=6535607a&scoped=true"
import script from "./TenancyTerm.vue?vue&type=script&lang=js"
export * from "./TenancyTerm.vue?vue&type=script&lang=js"
import style0 from "./TenancyTerm.vue?vue&type=style&index=0&id=6535607a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535607a",
  null
  
)

export default component.exports